import React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import { BottomSheetWrapperStyle } from './style';
import { Props } from './types';

const BottomSheet = (props: Props) => {
  const { children = null, withHandle = true, ...rest } = props;
  return (
    <>
      <SwipeableDrawer
        {...rest}
        anchor="bottom"
        disableSwipeToOpen
        PaperProps={{
          sx: {
            borderTopLeftRadius: props.type === 'full-page' ? 0 : 14,
            borderTopRightRadius: props.type === 'full-page' ? 0 : 14,
            overflow: 'hidden',
            ...props.PaperProps?.sx,
          },
        }}
      >
        <BottomSheetWrapperStyle>
          {withHandle && (
            <div className="handlebar">
              <div></div>
            </div>
          )}
          <div className="content">{children}</div>
        </BottomSheetWrapperStyle>
      </SwipeableDrawer>
    </>
  );
};

export default BottomSheet;
